import deephowApiServerWrapper from "@/server/api-server";

export const createUserQuizResult = async (params) => deephowApiServerWrapper("post", "/v1/user-quiz", params);

export const getUserQuizResult = async ({ userQuizId, skillId }) =>
  deephowApiServerWrapper("get", `/v1/user-quiz/${userQuizId}/`, { params: { skillId } });
